module.exports = __webpack_public_path__ + "static/media/sitting 2.975409f2.jpg";